import React, { useEffect, useState } from "react"
import Navigation from "./components/navigation"
import Editor from "./components/editor"
import Preview from "./components/preview"
import { getButtonActionId, getTemporaryBlockId } from "../../../../services/helpers/Helper"

const ChatBot = (props) => {
   const {
      data,
      onChange
   } = props;
   const { first_block, answer, blocks } = data;
   const [faqId, setFaqId] = useState();

   const onSelectFaq = (faq) => {
      setFaqId(getTemporaryBlockId(faq));
   }

   const onSelectFaqByButtonAction = (faq) => {
      setFaqId(getButtonActionId(faq));
   }

   const handleFirstSelect = () => {
      setFaqId(getTemporaryBlockId(first_block));
   }

   const getFaq = () => {
      let data = { cards: [], title: '' };
      if (getTemporaryBlockId(first_block) === faqId) {
         data = first_block;
      } else {
         data = blocks.find(f => getTemporaryBlockId(f) === faqId);
         if (data === undefined) {
            data = { cards: [], title: '' };
         }
      }
      return data;
   }

   useEffect(handleFirstSelect, [data.id]);

   return (
      <React.Fragment>
         <Navigation
            answer={answer}
            data={data}
            faq={getFaq()}
            onSelectFaq={onSelectFaq}
            onChange={onChange}
         />
         <Editor
            faq={getFaq()}
            data={data}
            onSelectFaq={onSelectFaq}
            onChange={onChange}
            onSelectFaqByButtonAction={onSelectFaqByButtonAction}
            faqId={faqId}
         />
         <Preview
            faq={getFaq()}
         />
      </React.Fragment>
   )
}

export default ChatBot;